import React, { Component } from 'react';
import { Checkbox, Col, Form, InputNumber, message, Modal, Row } from 'antd';
import util from '@util';
import moment from 'moment';
import UploadFile from '@comm/upload/UploadFile';

const FormItem = Form.Item;

class IndexModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visibleFlag: true,
      arr: [{}, {}],
      sum: 0,
    };
  }

  componentDidMount() {
    const { arr } = this.state;
    const { data } = this.props;
    const loanUuid = data.uuid;
    arr[0].loanUuid = loanUuid;
    arr[1].loanUuid = loanUuid;
    this.setState({
      arr,
    });
  }

  submit = e => {
    const { arr } = this.state;
    const paramsArr = [];
    let sum = 0;

    if (e) {
      e.preventDefault();
    }

    this.props.form.validateFields((err, values) => {
      if (!arr[0] && !arr[1]) {
        message.error('请选择核销类型');
        return;
      }

      if (arr[0]) {
        if (values.type0) {
          if (values.money0) {
            arr[0].type = 0;
            arr[0].price = values.money0;
            sum += arr[0].price;
            paramsArr.push(arr[0]);
          } else {
            message.error('借款归还信息填写不完整，如果不需要请取消选择');
            return;
          }
        }
      }

      if (arr[1]) {
        if (values.type1) {
          if (values.money1 && values.files && values.files.length > 0) {
            arr[1].type = 1;
            arr[1].price = values.money1;
            arr[1].files = values.files;
            sum += arr[1].price;
            paramsArr.push(arr[1]);
          } else {
            message.error('发票冲销信息填写不完整，如果不需要请取消选择');
            return;
          }
        }
      }

      if (sum !== +this.props.data.price) {
        message.error('核销金额与借款金额不一致');
        return;
      }

      this.setState({
        visibleFlag: false,
      });

      this.props.handleSubmit(paramsArr);
    });
  };

  // 改变复选框
  changeFlag = (index, e) => {
    const { arr } = this.state;
    const loanUuid = this.props.data.uuid;
    if (e.target.checked) {
      arr[index] = {
        loanUuid,
      };
    } else {
      arr[index] = null;
      this.props.form.resetFields(`money${index}`);
      this.changeMoney(3);
    }

    this.setState({
      arr,
    });
  };

  // 改变金额
  changeMoney = (index, e) => {
    let num0 = +this.props.form.getFieldValue('money0') || 0;
    let num1 = +this.props.form.getFieldValue('money1') || 0;
    index === 0 && (num0 = +e);
    index === 1 && (num1 = +e);
    const sum = num0 + num1;
    this.setState({
      sum,
    });
    return e;
  };

  render() {
    const { data = {} } = this.props;
    const { arr, visibleFlag } = this.state;
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    return (
      <Modal
        title={this.props.title}
        visible={visibleFlag}
        onOk={this.submit}
        onCancel={this.props.cancel}
        width="50%"
      >
        <Row style={{ marginBottom: '15px' }}>
          <Col span={8}>
            借款金额：
            <span>{data.price}</span>元
          </Col>
          <Col>
            借出时间：
            {data.createTime ? moment.unix(data.createTime / 1000).format('YYYY-MM-DD HH:MM') : ''}
          </Col>
        </Row>

        <Row
          style={{
            backgroundColor: '#FAFAFA',
            height: '40px',
            lineHeight: '40px',
            fontWeight: '900',
            borderBottom: '1px solid #E8E8E8',
          }}
        >
          <Col span={9} style={{ paddingLeft: '20px' }}>
            选择核销类型
          </Col>
          <Col span={7}>金额</Col>
          <Col span={8}>附件(发票)</Col>
        </Row>

        <Form {...formItemLayout} onSubmit={this.submit}>
          <Row style={{ marginTop: '15px', borderBottom: '1px solid #E8E8E8' }}>
            <Col span={7}>
              <FormItem>
                {getFieldDecorator(`type0`, {
                  initialValue: true,
                })(
                  <div>
                    <Checkbox onChange={() => this.changeFlag(0)} defaultChecked />
                    <span>借款归还</span>
                  </div>,
                )}
              </FormItem>
            </Col>
            <Col span={8}>
              <FormItem>
                {getFieldDecorator(`money0`, {
                  getValueFromEvent: e => this.changeMoney(0, e),
                })(
                  <InputNumber
                    placeholder="请填写金额"
                    min={0}
                    max={+data.price}
                    style={{ width: '100%' }}
                    disabled={!arr[0]}
                  />,
                )}
              </FormItem>
            </Col>
          </Row>
          <Row style={{ marginTop: '15px', borderBottom: '1px solid #E8E8E8' }}>
            <Col span={7}>
              <FormItem>
                {getFieldDecorator(`type1`, { initialValue: true })(
                  <div>
                    <Checkbox onChange={() => this.changeFlag(1)} defaultChecked />
                    <span>发票冲销</span>
                  </div>,
                )}
              </FormItem>
            </Col>
            <Col span={8}>
              <FormItem>
                {getFieldDecorator(`money1`, {
                  getValueFromEvent: e => this.changeMoney(1, e),
                })(
                  <InputNumber
                    placeholder="请填写金额"
                    min={0}
                    max={+data.price}
                    style={{ width: '100%' }}
                    disabled={!arr[1]}
                  />,
                )}
              </FormItem>
            </Col>
            <Col span={8}>
              <FormItem>
                {getFieldDecorator('files')(
                  <UploadFile type="ghost" disabled={!arr[1]} isPreview />,
                )}
              </FormItem>
            </Col>
          </Row>

          <Row type="flex" justify="start" align="middle" style={{ marginTop: '15px' }}>
            <Col span={1} />
            <Col span={7}>核销金额统计</Col>
            <Col span={8}>{util.numberFormat(this.state.sum, 2, '.', ',')}元</Col>
          </Row>
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(IndexModal);



// WEBPACK FOOTER //
// ./src/components/finance/loan/ModalWrite.js